import { cn } from "../../lib/utils/cn";

/** 순위 표 위 ※ 안내. 모든 줄을 글자 시작점에 맞춤 */
export default function RankingNotice({
  lines,
  className,
}: {
  lines: string[];
  className?: string;
}) {
  return (
    <div className={cn("flex gap-[4px] text-sm text-red-500", className)}>
      <span className="shrink-0">※</span>
      <div className="min-w-0 break-keep">
        {lines.map((line) => (
          <p key={line}>{line}</p>
        ))}
      </div>
    </div>
  );
}
